<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="90px">
            <el-form-item label="算法名称：" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20"
                          placeholder="请输入算法名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="脱敏类型：" prop="type">
                <el-select v-model="searchForm.type" clearable placeholder="请选择脱敏类型">
                    <el-option
                        v-for="item in zationTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="建立人：" prop="createBy">
                <el-select v-model="searchForm.createBy" filterable clearable placeholder="请选择建立人">
                    <el-option
                        v-for="item in peopleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期:" prop="dataTime">
                <el-date-picker
                    v-model="searchForm.dataTime"
                    clearable
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="p_all1">
            <el-button v-if="hasPermission('sys:desensitize:desensitizeList:add')" type="primary" size="small" icon="el-icon-plus" @click="addData('add')">新增</el-button>
            <el-button v-if="hasPermission('sys:desensitize:desensitizeList:deleteData')" type="danger" size="small" icon="el-icon-delete" @click="deleteData()">批量删除</el-button>
        </div>
        <div class="tips"><el-link class="el-icon-info" type="primary" :underline="false"></el-link>已选择{{dataListSelect.length}}项数据</div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border
                ref="multipleTable"
                :row-key="'id'"
                @sort-change="sortChange"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column :reserve-selection="true" type="selection" width="50"/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="算法名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="脱敏类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="switchType" width="100px" label="状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-tag size="small" v-if="row.switchType == 0" type="success">启用</el-tag>
                    <el-tag size="small" v-else type="danger">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" sortable="custom" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" min-width="100px" label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="hasPermission(`sys:desensitize:desensitizeList:see`)" type="text" size="small" @click="addData('see',row)">查看</el-button>
                    <el-button v-if="hasPermission(`sys:desensitize:desensitizeList:edit`)" type="text" size="small" @click="addData('edit',row)">编辑</el-button>
                    <el-button v-if="hasPermission(`sys:desensitize:desensitizeList:deleteData`)" type="text" size="small" @click="deleteData(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-desensitize ref="addDesensitize" @refresh="refreshList(1,1)"></add-desensitize>
    </div>
</template>

<script>

import AddDesensitize from "@/views/modules/sys/desensitize/addDesensitize.vue";

export default {
    name: "processList",
    components: {AddDesensitize},
    data() {
        return {
            searchForm: {
                name: '',
                type:'',
                createBy:'',
                dataTime:[],
                beginTime:'',
                endTime:'',
                current: 1,
                size: 20,
            },
            total: 0,
            zationTypeList:[
                {
                    label:'字符型',
                    value:'0',
                },
                {
                    label:'数值型',
                    value:'1',
                },
            ],
            peopleList:[],

            sort:'',
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
        this.$axios(this.api.metadata.selectAllUser, {}).then(data => {
            if (data && data.status) {
                this.peopleList = []
                Object.keys(data.data).forEach(key=>{
                    this.peopleList.push({
                        id:key,
                        name:data.data[key],
                    })
                })
            }
        })
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            if (this.searchForm.dataTime && this.searchForm.dataTime.length != 0) {
                this.searchForm.beginTime = this.searchForm.dataTime[0]
                this.searchForm.endTime = this.searchForm.dataTime[1]
            }else {
                this.searchForm.beginTime = ''
                this.searchForm.endTime = ''
            }
            this.loading = true
            this.$axios(this.api.metadata.releasesDesensitizationList, {
                ...this.searchForm,
                sort:this.sort,
            },'post').then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        // 列表排序
        sortChange(column, type) {
            this.sort = ''
            if (column.order){
                if (column.prop == 'createTime') {
                    this.sort = 'create_time ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
                }
            }
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //typeName see查看 edit编辑 add新增
        addData(typeName,row){
            this.$refs.addDesensitize.init(typeName,row)
        },

        //删除
        deleteData(row){
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.status == 0){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`确认删除所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.metadata.releasesDesensitizationRemoveByIds, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },





    }
}
</script>

<style scoped>
.tips {
    padding: 4px;
    .el-icon-info {
        margin-right: 6px;
    }
}
</style>